import { Despatch } from 'src/components/biz-despatch';

export default Despatch;
